const path = window.require("path");
const { app } = window.require("@electron/remote");
const protobuf = window.require("protobufjs");

function getRoot() {
  if (path && app && protobuf) {
    const communicationPath = path.join(
      app.getAppPath(),
      "modules/media-upload-protobuf/media-upload.proto"
    );
    const protoRoot = protobuf.loadSync(communicationPath);

    return protoRoot;
  }

  return new Proxy(
    {},
    {
      get(obj, prop) {
        if (window.mediaUploadRoot) {
          return window.mediaUploadRoot[prop];
        }

        if (prop === "lookupType") return () => undefined;
        if (prop === "lookupEnum") return () => undefined;
        return undefined;
      }
    }
  );
}

const protoRoot = getRoot();

export default protoRoot;

const Type = {
  get Message() {
    return protoRoot.lookupType("upload.Message");
  },
  get DataMessage() {
    return protoRoot.lookupType("upload.DataMessage");
  },
  get MediaType() {
    return protoRoot.lookupEnum("upload.MediaType");
  },
  get FileType() {
    return protoRoot.lookupEnum("upload.FileType");
  },
  get PrepareUploadMessage() {
    return protoRoot.lookupType("upload.PrepareUploadMessage");
  },
  get FinishUploadMessage() {
    return protoRoot.lookupType("upload.FinishUploadMessage");
  }
};

export { Type };
